import { isoStringToUTCDate } from '../dates';
import { TicketAvailability } from '../../enums';

import {
  getAllTicketsForRace,
  getTicketAvailability,
  getTicketAvailabilityType,
} from '../ticket';

/**
 * Returns an ISOString date of the next available "coming soon" ticket.
 */
export default (races = []) => {
  const availabileFromDates = []
    .concat(...races.map(getAllTicketsForRace))
    .filter(
      (t) => getTicketAvailabilityType(t) === TicketAvailability.COMING_SOON,
    )
    .map((t) => getTicketAvailability(t).from)
    .filter((i) => i)
    .sort((a, b) => isoStringToUTCDate(a) - isoStringToUTCDate(b));

  return availabileFromDates[0] || null;
};
